import { SlotGameType1_21 } from '../SlotGameType1_21';

export class SpiritsOfTheThunderFillingPot21 extends SlotGameType1_21
{
}
